/* <artifact-specification>

I need a card it should show the ConnectorLogo image centered, below the text "Link your ${Connector} account" and a button "Link accounts" below. when clicked it should redirect to AuthorizeUrl

based on the following props:

{ data: 
{
    "ErrorText": "Authorization required",
    "ErrorCode": 461,
    "Connector": "Jira",
    "ConnectorName": "jira",
    "AuthorizeUrl": "https://app.adenin.com/oauth2connector/authorize/jira",
    "ConnectorLogo": "https://www.adenin.com/assets/logos/jira.svg",
    "__connector": "jira",
    "_hash": "b896463c6748619d9c720c44cb074bd1"
}}

</artifact-specification> */

import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const APIError461 = ({ data = {} }) => {
  const {
    Connector = "",
    ConnectorLogo = "",
    AuthorizeUrl = ""
  } = data;

  const handleLinkClick = () => {
    window.location.href = AuthorizeUrl;
  };

  return (
    <Card className="w-full max-w-sm mx-auto">
      <CardContent className="flex flex-col items-center space-y-6 pt-6">
        <div className="w-20 h-20 flex items-center justify-center">
          <img 
            src={ConnectorLogo} 
            alt={`${Connector} logo`}
            className="max-w-full max-h-full object-contain"
          />
        </div>
        
        <p className="text-lg text-center text-foreground">
          Link your {Connector} account
        </p>

        <Button 
          onClick={handleLinkClick}
          className="w-full"
        >
          Link accounts
        </Button>
      </CardContent>
    </Card>
  );
};

export default APIError461;